import { Helmet } from "react-helmet-async";
import Header from "@/components/landing/Header";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import HomeHero from "@/components/home/HomeHero";
import { NeedsSplit, FondeaShowcase } from "@/components/home/HomeFondea";
import HomeWhiteLabel from "@/components/home/HomeWhiteLabel";
import { CasesTeaser, DualCTA } from "@/components/home/HomeClosing";
import HomeWhyIbylit from "@/components/home/HomeWhyIbylit";
import FintechFooter from "@/components/landing/FintechFooter";
const Index = () => {
  useScrollReveal();
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>IBYLIT — Conectamos empresas, bancos y capital</title>
        <meta
          name="description"
          content="Infraestructura financiera que integra facturación, pagos y financiamiento. FONDEA para empresas y SOLVENN para instituciones financieras en LATAM."
        />
        <link rel="canonical" href="https://ibylit.com/" />
        <meta property="og:title" content="IBYLIT — Conectamos empresas, bancos y capital" />
        <meta
          property="og:description"
          content="Conectamos empresas con liquidez. Entidades financieras con nuevas oportunidades."
        />
        <meta property="og:url" content="https://ibylit.com/" />
        <meta name="twitter:title" content="IBYLIT — Conectamos empresas, bancos y capital" />
        <meta
          name="twitter:description"
          content="Conectamos empresas con liquidez. Entidades financieras con nuevas oportunidades."
        />
      </Helmet>
      <Header />
      <main id="main-content" tabIndex={-1}>
        <div data-skip-reveal="true">
          <HomeHero />
        </div>
        <NeedsSplit />
        <FondeaShowcase />
        <HomeWhiteLabel compact />
        <HomeWhyIbylit />
        <CasesTeaser />
        <DualCTA />
      </main>
      <FintechFooter />
    </div>
  );
};

export default Index;
